<template>

    <div :style="{ height: size + 'px', width: size + 'px' }">

        <div v-if="$mq !== 'lg'">

            <lottie
                :options="mobileOptions"
                v-on:animCreated="handleAnimation"
            />

        </div>

        <div v-else>

            <lottie
                :options="desktopOptions"
                v-on:animCreated="handleAnimation"
            />

        </div>

    </div>

</template>

<script>

import Lottie from 'vue-lottie'

import * as animationDataMobile from '../../../public/img/lottie/checkFetch/cleanfox-check-mobile.json'
import * as animationDataDesktop from '../../../public/img/lottie/checkFetch/cleanfox-check-desktop.json'

export default {

    name: 'lottie-check',

    components: {Lottie},

    props: {

        size: {
            type: Number,
            default: 40
        }
    },

    data() {
        return {
            mobileOptions: {animationData: animationDataMobile.default},
            desktopOptions: {animationData: animationDataDesktop.default},
            anim: null,
            animationSpeed: 0
        }
    },

    methods: {

        handleAnimation: function (anim) {
            anim.setSpeed(0.5)
            anim.loop = false
            this.anim = anim
        },

        stop: function () {
            this.anim.stop()
        },

        play: function () {
            this.anim.play()
        },

        pause: function () {
            this.anim.pause()
        },

        onSpeedChange: function () {
            this.anim.setSpeed(this.animationSpeed)
        }
    }

}

</script>

<style lang="scss" scoped></style>
